import { SVGIcon } from '@/components/SVGIcon/SVGIcon';
import { IconName } from '@/components/SVGIcon/SVGIcon.types';
import React from 'react';

interface VehicleParameterItemProps {
  label: string;
  value: string;
  icon?: IconName;
  fillColor?: string;
  className?: string;
}

export const VehicleParameterItem: React.FC<VehicleParameterItemProps> = ({
  label,
  value,
  icon,
  fillColor,
  className = '',
}) => {
  if (!value) return null;

  return (
    <div
      className={`my-auto flex w-[222px] min-w-60 shrink grow items-center gap-3.5 self-stretch pl-5 ${className}`}
    >
      {icon && (
        <div className="my-auto flex h-9 w-9 shrink-0 items-center justify-center gap-2.5 rounded-[10px] bg-gray-100">
          <SVGIcon name={icon} className="h-6 w-6" fill={fillColor} />
        </div>
      )}
      <div className="my-auto flex flex-col self-stretch rounded-none">
        <div className="text-sm leading-none text-gray-500">{label}</div>
        <div className="mt-1 self-start text-sm font-semibold leading-none text-zinc-800">
          {value}
        </div>
      </div>
    </div>
  );
};
